<app-entity-mat-dialog-title title="AMI Reporting Settings"></app-entity-mat-dialog-title>
<div mat-dialog-content>
    <mat-progress-spinner class="mx-auto my-3" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

    <form [formGroup]="amiReportingForm" *ngIf="!showProgressSpinner">
      <app-success-message [message]=this.successMessage></app-success-message>
      <app-error-message [message]=this.errorMessage></app-error-message>

      <!-- Environment Preset Selection -->
      <div class="mb-3" *ngIf="hasAdminAccess()">
        <label class="form-label fw-semibold">Environment Preset:</label>
        <div class="d-flex gap-2">
          <button type="button" mat-raised-button
                  [color]="selectedEnvironment === 'none' ? 'warn' : ''"
                  (click)="applyEnvironmentPreset('none')" class="flex-fill">
            <mat-icon>block</mat-icon> None
          </button>
          <button type="button" mat-raised-button
                  [color]="selectedEnvironment === 'live' ? 'primary' : ''"
                  (click)="applyEnvironmentPreset('live')" class="flex-fill">
            <mat-icon>cloud</mat-icon> Live
          </button>
          <button type="button" mat-raised-button
                  [color]="selectedEnvironment === 'testing' ? 'accent' : ''"
                  (click)="applyEnvironmentPreset('testing')" class="flex-fill">
            <mat-icon>science</mat-icon> Testing
          </button>
        </div>
      </div>

      <mat-divider class="mb-3" *ngIf="hasAdminAccess()"></mat-divider>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>AMI Address</mat-label>
        <input matInput formControlName="amiAddress" [readonly]="isFieldReadonly('amiAddress')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('amiAddress')">lock</mat-icon>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Client ID</mat-label>
        <input matInput formControlName="clientId" [readonly]="isFieldReadonly('clientId')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('clientId')">lock</mat-icon>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Grant Type</mat-label>
        <input matInput formControlName="grantType" [readonly]="isFieldReadonly('grantType')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('grantType')">lock</mat-icon>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Client Secret</mat-label>
        <input matInput formControlName="clientSecret" [readonly]="isFieldReadonly('clientSecret')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('clientSecret')">lock</mat-icon>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Username</mat-label>
        <input matInput formControlName="username" [readonly]="isFieldReadonly('username')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('username')">lock</mat-icon>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" [readonly]="isFieldReadonly('password')">
        <mat-icon matSuffix *ngIf="isFieldReadonly('password')">lock</mat-icon>
      </mat-form-field>
    </form>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary"
          [disabled]="!amiReportingForm.valid || !hasAdminAccess() || showProgressSpinner"
          (click)="actionType === 'create' ? onSubmit() : onUpdate()">
    <mat-spinner *ngIf="showProgressSpinner" diameter="20" class="d-inline-block"></mat-spinner>
    <span *ngIf="!showProgressSpinner">{{ actionType === 'create' ? 'Save' : 'Update' }}</span>
  </button>
</mat-dialog-actions>
